module.exports = __webpack_public_path__ + "img/earthmap4k.94804267.jpg";